import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { useAuth } from '../hooks/useAuth';
import { AlertTriangle, ArrowLeft } from 'lucide-react';
interface LoginPageProps {
  onNavigate: (page: string) => void;
}
export function LoginPage({
  onNavigate
}: LoginPageProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const {
    login
  } = useAuth();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (login(password)) {
      onNavigate('app');
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };
  return <div className="min-h-screen bg-primary-gradient flex items-center justify-center p-4" data-id="element-751">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 animate-in zoom-in-95 duration-300" data-id="element-752">
        <div className="text-center mb-8" data-id="element-753">
          <img src="https://cdn.magicpatterns.com/uploads/cF6vjSgtA8zA3PrUGfuAMk/KB_Signature_(1).png" alt="Zapiis" className="h-12 mx-auto mb-2" data-id="element-754" />
          <p className="text-gray-500 font-medium" data-id="element-755">Beta Access Portal</p>
        </div>

        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-8 flex items-start gap-3" data-id="element-756">
          <AlertTriangle className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" data-id="element-757" />
          <p className="text-sm text-yellow-800" data-id="element-758">
            <strong data-id="element-759">Beta Version</strong> - For authorized testers only. Please
            enter your access code to continue.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-760">
          <Input type="password" label="Enter Beta Access Password" placeholder="••••••••" value={password} onChange={e => {
          setPassword(e.target.value);
          setError('');
        }} error={error} autoFocus data-id="element-761" />

          <Button type="submit" className="w-full" size="lg" data-id="element-762">
            Access Beta App
          </Button>
        </form>

        <div className="mt-6 text-center" data-id="element-763">
          <button onClick={() => onNavigate('landing')} className="text-sm text-gray-500 hover:text-primary-purple flex items-center justify-center gap-1 mx-auto" data-id="element-764">
            <ArrowLeft className="w-4 h-4" data-id="element-765" />
            Back to main site
          </button>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-100 text-center" data-id="element-766">
          <div className="bg-blue-50 rounded-lg p-4 text-sm text-blue-800" data-id="element-767">
            <p className="font-bold mb-1" data-id="element-768">Don't have beta access?</p>
            <p data-id="element-769">
              Join our waitlist to be notified when the full version launches.
            </p>
          </div>
        </div>
      </div>
    </div>;
}